import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'
import Config from '@/data/config.js'

export default class AuthService {
    constructor(passwordCrypter) {
        this.passwordCrypter = passwordCrypter
        this.apis = {
            login: payload => axios.post(APIConfig.APIURL + '/login', payload),
            refresh: payload => axios.post(APIConfig.APIURL + '/refresh', payload)
        }
    }

    getJWT() {
        return localStorage.getItem(Config.jwtStorageKey)
    }

    saveJWT(jwt) {
        localStorage.setItem(Config.jwtStorageKey, jwt)
    }

    isJWTValid(jwt) {
        try {
            let jwtArr = jwt.split('.')
            let exp = JSON.parse(atob(jwtArr[1])).exp
            if (exp) return Math.floor(Date.now() / 1000) < exp
        } catch (err) {
            window.console.error(err)
        }
        return false
    }

    isLogined(vm) {
        let jwt = this.getJWT()
        if (!jwt) return false
        return this.isJWTValid(jwt)
    }

    logout(vm) {
        localStorage.removeItem(Config.jwtStorageKey)
    }

    login(vm, paramsInput) {
        var params = JSON.parse(JSON.stringify(paramsInput))
        return new Promise((resolve, reject) => {
            var inputPassword = params.password
            params.password = this.passwordCrypter.cryptPassword(params.password)
            this.apis.login(params)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        let token = res.data.result
                        this.saveJWT(token)
                        vm.$store.state.myID = JSON.parse(atob(token.split(".")[1])).ID;
                        axios.defaults.headers['Authorization'] = `Bearer ${token}`
                        resolve(token)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    params.password = inputPassword
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    refresh (vm) {
        // vm.isLoading = true
        let params = {}
        return this.apis.refresh(params)
          .then(res => {
            let ok = res && res.data && res.data.status === 'ok'
            if (ok) {
              let token = res.data.result
              this.saveJWT(token)
              axios.defaults.headers['Authorization'] = `Bearer ${token}`
              return res.data.result
            }
            if (res && res.data && res.data.error) throw res.data.error
            var msg = '未知的錯誤'
            throw msg
          })
    }
}
